// extracted by mini-css-extract-plugin
export default {"agentTile":"AgentTile_agentTile__j8I1j","agentValue":"AgentTile_agentValue__eU6wl","arrow":"AgentTile_arrow__bf-1H"};